// Third-party
import { useTranslation } from 'react-i18next';

// Redux-toolkit
import { TDialogAction, BaseDialog } from '@mgm/common/components/base';
import { useDeleteCommissionPlanAPI } from '../../../hooks/api/useCommissions';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppStore';
import { getToggleDeleteDialog } from '../../../store/commissions/selectors';
import { commissionsActions } from '../../../store/commissions/slice';

const DeletePlanDialog = () => {
  const { t } = useTranslation(['common', 'commissions']);
  const { mutateAsync: deleteMutate, isLoading } = useDeleteCommissionPlanAPI();
  const isOpenDialog = useAppSelector(getToggleDeleteDialog);
  const dispatch = useAppDispatch();

  const handleCloseDialog = () => {
    dispatch(commissionsActions.setToggleDeleteDialog(false));
  };

  const deleteShift = async () => {
    await deleteMutate();
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel'),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleCloseDialog(),
    },
    {
      label: t('delete'),
      color: 'primary',
      isLoading,
      onClick: () => deleteShift(),
    },
  ];

  return (
    <BaseDialog
      dialogContent={t('areYouSureYouWantToDelete', { ns: 'commissions' })}
      isOpenDialog={isOpenDialog}
      dialogTitle={t('deleteCommissionPlan', { ns: 'commissions' })}
      handleClose={handleCloseDialog}
      dialogActions={dialogActions}
    />
  );
};

export {
  DeletePlanDialog,
};
